export const subtitles = {
    "1": {
        "startTime": 4.86,
        "endTime": 7.94,
        "transcript": "Tua-i-wa waniw' Qunuin atam taiqaa.",
        "translation": "Well now, Qunuin, come here."
    },
    "2": {
        "startTime": 8.38,
        "endTime": 12.96,
        "transcript": "Waniwa allamek eneqanaitua, yaa.",
        "translation": "Now, I don't have any other memories, yes."
    },
    "3": {
        "startTime": 12.965,
        "endTime": 18.285,
        "transcript": "Au͡g'umek tau͡gaam yugnek angullemnek eneqanangqertua.",
        "translation": "However, I have memories of the people I was born in time to see."
    },
    "4": {
        "startTime": 18.94,
        "endTime": 25.22,
        "transcript": "Waniw' au͡g'umek ciuqlillarmek waniw' qanrucuumirluci qanrucugyaaqanka. (Yaa, okay, yaa.)",
        "translation": "I want to tell them about the old ones before. (Yes, okay, yes.)"
    },
    "5": {
        "startTime": 25.845,
        "endTime": 27.935,
        "transcript": "Tangerrluku tua-i.",
        "translation": "If it is opportune."
    },
    "6": {
        "startTime": 28.685,
        "endTime": 34.695,
        "transcript": "Waniwa ellangellrulria tang amani Cevv'arnermiuni.",
        "translation": "You see, I grew up over in Chefornak."
    },
    "7": {
        "startTime": 35.525,
        "endTime": 42.805,
        "transcript": "Tua-i Cevv'arnermini ellangellruunga. Tua-i maaten...",
        "translation": "I grew up in Chefornak. It turned out..."
    },
    "8": {
        "startTime": 42.811,
        "endTime": 56.778,
        "transcript": "[Kinguq]lirkaita-llu, kinguqliput-gguq kinguqlirkait nunam maani qaingani yuum ayuqucirkaanek ayagniriciqut.",
        "translation": "And their descendants, they said that the descendants of our descendants would begin what people would be like on this earth."
    },
    "9": {
        "startTime": 58.19,
        "endTime": 60.55,
        "transcript": "Ayagniriciqut.",
        "translation": "They will start it."
    },
    "10": {
        "startTime": 61.287,
        "endTime": 77.612,
        "transcript": "Nutaan-llu-gguq tua-i kinguqliit ukegkut tua-i imutun tuar tang imna man'a maa-i mat'um nalliini yuut atungekiit man'a.",
        "translation": "And then they said that their future descendants, it seems that the people have started going through this these days."
    },
    "11": {
        "startTime": 79.043,
        "endTime": 82.531,
        "transcript": "Tangvagluku tuar qalartelallrulriit.",
        "translation": "It seemed they spoke as if seeing it."
    },
    "12": {
        "startTime": 83.019,
        "endTime": 87.481,
        "transcript": "Maaten waniwa waten elliama umyuaqnaunka.",
        "translation": "I reached this age and remember them."
    },
    "13": {
        "startTime": 87.619,
        "endTime": 94.619,
        "transcript": "Tuar im' tangvagluki nunat makut yugkait qanrutkelallrukiit.",
        "translation": "They talked about it as if they were looking at the people that would live in these lands."
    },
    "14": {
        "startTime": 95.638,
        "endTime": 97.738,
        "transcript": "Akleng-gguq.",
        "translation": "They said, \"Pity.\""
    },
    "15": {
        "startTime": 98.132,
        "endTime": 110.782,
        "transcript": "Tamana-gguq tekiskunegteggu tuaten ellillerkarteng imutun makut-ll' ayagyuarit qimugkara'urlurtun ellirciqut.",
        "translation": "They said that when they have reached the point that they would become like that, even the young people would become like puppies."
    },
    "16": {
        "startTime": 111.514,
        "endTime": 114.626,
        "transcript": "Tangrriu maa-i.",
        "translation": "Look at it now."
    },
    "17": {
        "startTime": 115.002,
        "endTime": 126.389,
        "transcript": "Taringutkeqapiaralaranka au͡gkut yuut tuar tang imna man'a tua-i tangvakapiarluku qanrutkelallrukiit.",
        "translation": "I completely understand that those people would talk about this time as if they were truly seeing it."
    },
    "18": {
        "startTime": 127.114,
        "endTime": 134.514,
        "transcript": "Aling aren, maa-i-ll' tua-i tekilluku yuut makut, nunat yuita tamarmeng.",
        "translation": "Oh my goodness, and now, these people have reached it, every person from the villages."
    },
    "19": {
        "startTime": 134.746,
        "endTime": 139.608,
        "transcript": "Naliat-llu pinritevkenani, nunat tamarmeng tekilluku.",
        "translation": "And none of them was left out as all villages reached it."
    },
    "20": {
        "startTime": 140.584,
        "endTime": 153.871,
        "transcript": "Tua-i-gguq tuaten ellirarkaugut makut ayagyuat qanruyut'seng man'a cakenriqunegteggu, qanruyut'seng atunriqunegteggu.",
        "translation": "They said that people would become like when the young people start disregarding traditional wisdom, when they don't adhere to traditional wisdom anymore."
    },
    "21": {
        "startTime": 154.834,
        "endTime": 163.359,
        "transcript": "Aling aren, wiinga tang tua-i imum-llu ap'ama yaani Cevv'arnermiuni wagg'uq uum Elegtam",
        "translation": "Oh my goodness, also, my grandfather over in Chefornak who was known as Elegtaq"
    },
    "22": {
        "startTime": 164.54,
        "endTime": 176.215,
        "transcript": "Tua-i tauna Elegtaq ap'aka qanemcitullruuq. Agaani ellangellruyaaqelliniuq Iigmiut unegkut nuniitni, kiatiitni.",
        "translation": "My grandfather Elegtaq would tell stories. Apaprently, he grew up across there around Eek, upriver from there."
    },
    "23": {
        "startTime": 176.784,
        "endTime": 185.346,
        "transcript": "Wagg'uq wani Allauguullrini. Tauna ap'aka Elegtaq tamakumiunguyaaqelliniuq.",
        "translation": "They called that place Allauguulleq. My grandfather Elegtaq was from there."
    },
    "24": {
        "startTime": 185.722,
        "endTime": 197.022,
        "transcript": "Tua-i imna-llu tanglallrukeka wii keggani Qaluyaani Aluskam Arnaanek pilallrat arnassagaq au͡gna.",
        "translation": "I also used to see the old woman they called Aluskaq's Mother out there on Nelson Island."
    },
    "25": {
        "startTime": 197.241,
        "endTime": 203.729,
        "transcript": "Tauna-llu-gguq tamatum nalliini Allauguullratni unisngatellrunrituk.",
        "translation": "He said that they were not separated when it was called Allgauguulleq."
    },
    "26": {
        "startTime": 203.934,
        "endTime": 211.647,
        "transcript": "Tua-i-gguq yuuciak man'a unisngatellrunrituq taukuk yuuk.",
        "translation": "He said that their lives were not apart from each other."
    },
    "27": {
        "startTime": 212.922,
        "endTime": 226.109,
        "transcript": "Aren tua-i waniwa mat'umek au͡g'umek ava-i qanemciqertua. Tangrriu waten atam.",
        "translation": "Well, I have just told that story. Consider it like this."
    },
    "28": {
        "startTime": 226.372,
        "endTime": 237.709,
        "transcript": "Tua-i wiinga'urluq-llu waniwa qanruyun tamalkuan atunrilengramku tua-i tau͡gaam ukvertallruunga.",
        "translation": "And, pity me, even though I didn't use all of the traditional wisdom, I believed."
    },
    "29": {
        "startTime": 238.109,
        "endTime": 246.472,
        "transcript": "Ukvertallruunga qanruyukaramnek. Tamalkuan niisngayugnaicaaqaqa qanruyuteka.",
        "translation": "I believed what little wisdom was passed down to me. I have not obeyed every piece of wisdom passed down to me though."
    },
    "30": {
        "startTime": 247.209,
        "endTime": 253.709,
        "transcript": "Tua-i tau͡gaam qanelriamek niitaqama ukvetullruunga.",
        "translation": "But when I heard people instructing, I would believe."
    },
    "31": {
        "startTime": 254.591,
        "endTime": 259.803,
        "transcript": "Cali imkut qanrutestekama waten pitullruatnga:",
        "translation": "Also, my instructors would tell me this:"
    },
    "32": {
        "startTime": 259.879,
        "endTime": 269.816,
        "transcript": "\"Kitaki tangerrluku ilavnek qaillun pimaluten ping'e'rpet angurrlugmek tukaqlugcaqunek.",
        "translation": "\"Now see here, even if any of your peers do anything to you, never retaliate with bad intent."
    },
    "33": {
        "startTime": 271.154,
        "endTime": 277.216,
        "transcript": "\"Ilalciarluten yuulaqina angurrluk' ellaicetun ayuqevkenak.",
        "translation": "\"Live by treating people well, and never be like them."
    },
    "34": {
        "startTime": 277.317,
        "endTime": 286.204,
        "transcript": "\"Tau͡gaam tauna-llu pistellren elluarrluku cali ciukirpianun cali uputniaran, aulukniaran.\"",
        "translation": "\"Instead, speak of and treat that person who wronged you well until he goes forth as a better person.\""
    },
    "35": {
        "startTime": 286.679,
        "endTime": 301.854,
        "transcript": "Tua-i aren tamana aturluku ilumun tua-i yuum ilii ilumun pillrulliaqami ulurmiayaaqvigminek taq'aqan quyalallruunga cakneq. Quyapialallruunga cakneq.",
        "translation": "Oh my, when a person indeed had done bad, I would be extremely thankful when they would stop looking back. I would be extremely thankful."
    },
    "36": {
        "startTime": 303.135,
        "endTime": 309.698,
        "transcript": "Tua-i umyuallguteksagutaqamku wii quyapiarutek'lallruaqa.",
        "translation": "When we came to an agreement, I would be very thankful for him."
    },
    "37": {
        "startTime": 312.535,
        "endTime": 322.948,
        "transcript": "Aling aren, tua-i waniw' au͡g'umek tua-i qanemciqertua tua-i waniwa.",
        "translation": "Oh my goodness, I just told that story now."
    },
    "38": {
        "startTime": 323.21,
        "endTime": 332.91,
        "transcript": "Au͡gna anguqallma ilii carraquiner au͡gna qanemcikaqa tua-i ava-i carraquiner.",
        "translation": "I told very little of the story of one of the people I was born in time to see, very little."
    },
    "39": {
        "startTime": 333.654,
        "endTime": 341.842,
        "transcript": "Tua-ll' imna waniwa watuam cali nalliinek tua-i waniw' piqaqatartua, uicung'.",
        "translation": "And now, I'm going to speak about current times, cousin."
    },
    "40": {
        "startTime": 343.18,
        "endTime": 355.267,
        "transcript": "Tua-i watuam nalliini waniwa atam irniangqellruyaaqelrianga tang waten, waten qulnek pingayunek cipluki.",
        "translation": "These days, you see, I had this many children, thirteen."
    },
    "41": {
        "startTime": 356.204,
        "endTime": 372.392,
        "transcript": "Tua-lli-wa waniwa umyuama kanangnuullra maligtesciigataqa wangnek pingaitelliniama kanangnuuryaaqekuma, imkut tau͡gaam wangnek ayallret.",
        "translation": "And now, I cannot succumb to my mind's dejection, because I will not be doing it to myself when I am dejected, but to those who've gone."
    },
    "42": {
        "startTime": 372.955,
        "endTime": 377.555,
        "transcript": "Tua-i waniw' teguyunairutnayukluki-ll' Agayutmun.",
        "translation": "Also, I fear that they may no longer by worthy to be taken by God."
    },
    "43": {
        "startTime": 377.887,
        "endTime": 385.649,
        "transcript": "Tau͡gaam Agayutmek quyamalartua waniwa tangercet'laaki imkut ayagcianka.",
        "translation": "But I thank God because he lets me see those who've gone from me."
    },
    "44": {
        "startTime": 385.9,
        "endTime": 392.0,
        "transcript": "Ellmeggnek tangerceteksaitut, tau͡gaam Agayutem tangercet'larai.",
        "translation": "They didn't show themselves, but God lets me see them."
    },
    "45": {
        "startTime": 392.182,
        "endTime": 400.707,
        "transcript": "Atam unugmi-am uitaurau͡rlulrianga maklua, allavkenii-llam cuyat teguluki iqmiglua.",
        "translation": "You see, I woke up and night and relaxes, and without deviating, I took my tobacco and chewed."
    },
    "46": {
        "startTime": 400.851,
        "endTime": 412.313,
        "transcript": "Iqmigtuumalnguama-ll' anlluki qemaggluki iqmiutaagka mayurrlukek. Kelutmun waten iggagarrlua tua-i waten maktallagglua uitaqerlua.",
        "translation": "And when I had chewed for long enough, I took them out, put them in, and put up the container. I lay facing the back of the bed, and shot up and stayed still."
    },
    "47": {
        "startTime": 412.939,
        "endTime": 419.514,
        "transcript": "Aren, uitaqainanemni ayuquciqa man'a tanqigpallartuq.",
        "translation": "Oh my, as I was staying still, there was a bright light around me."
    },
    "48": {
        "startTime": 419.92,
        "endTime": 431.695,
        "transcript": "Aren, tanqiim tuc'anga uigarrlua qulka tangrraqa tuar tang imna pikani qulemni waten tanqik uivenqellria.",
        "translation": "Oh my, when the light came upon me, I opened my eyes and looked up to what looked like a circle of light above me."
    },
    "49": {
        "startTime": 432.051,
        "endTime": 435.501,
        "transcript": "Yuut-wa pikegkut pingayun imai.",
        "translation": "There were three people inside."
    },
    "50": {
        "startTime": 435.958,
        "endTime": 444.72,
        "transcript": "Maaten tang tua-i pikavet tangvakaranka yuunka pikegkut tanqiim imaqluki.",
        "translation": "I looked up to find that the light up there enveloped my children."
    },
    "51": {
        "startTime": 445.558,
        "endTime": 455.233,
        "transcript": "Una tua-i alqaat Pangall'aq, Nanugaq-wa, ug'umek aanallgutmeggnek Uyanguamek pingayurlutek.",
        "translation": "Here was their older sister Pangall'aq, Nanugaq, and the third was Uyanguaq with whom they shared a mother downriver."
    },
    "52": {
        "startTime": 455.602,
        "endTime": 461.602,
        "transcript": "Imkunek atulqenrilkeḿeggnek aturluteng pakemkumiutarnek.",
        "translation": "They were wearing Heavenly clothes that they never wore before."
    },
    "53": {
        "startTime": 462.359,
        "endTime": 466.946,
        "transcript": "Aren, tua-i pikegkut angnirluteng arenqialkiitnga.",
        "translation": "Oh my, there were happy up there and pitied me."
    },
    "54": {
        "startTime": 466.959,
        "endTime": 473.871,
        "transcript": "Tua-i ketmun caukanirluki wii ciuggvikluki pikavet tangvaganka tua-i.",
        "translation": "I faced the front of the bed toward them, looked up, and watched them."
    },
    "55": {
        "startTime": 473.884,
        "endTime": 477.884,
        "transcript": "Tangrrucimtun Agayun quyavikaqa.",
        "translation": "As I saw them, I thanked God."
    },
    "56": {
        "startTime": 478.641,
        "endTime": 488.428,
        "transcript": "Tua-i quyavikluku allam tangercetenrilaki, tua-i elliin tau͡gaam tangercecaki.",
        "translation": "I thanked him because no other allowed me to see them, only he allowed me to see them."
    },
    "57": {
        "startTime": 490.553,
        "endTime": 506.478,
        "transcript": "Atam tua-i taqlua uitaqanemkun pakemna nuniitnek, uluqsaunaki-ll' tangviimki, nuniitnek qanelria angutnguluni. Aling nallunripakar.",
        "translation": "You seem as I stopped and stayed still, up from where they were, because I didn't look away from them, a man spoke from where they were. Wow, he definitely knows."
    },
    "58": {
        "startTime": 507.234,
        "endTime": 513.709,
        "transcript": "\"Mary, elpet-ll' waten pimaciquten ukucetun.\"",
        "translation": "\"Mary, you will also be like this as these are.\""
    },
    "59": {
        "startTime": 513.94,
        "endTime": 524.978,
        "transcript": "Aren, watua cayukataryuklua ugkurluut tutgaraanka tua-i iluvaqertut wangni wavet ciuqamnun.",
        "translation": "Oh my, I thought I was going to be pulled away right then, but my dear grandchildren from out there appeared here in front of me."
    },
    "60": {
        "startTime": 525.578,
        "endTime": 534.916,
        "transcript": "Arenqiapaa tua-i iluvaqercata waniwa tua-i kiima tangvanga'arcamegteńga imkurtut...",
        "translation": "My goodness, when they appeared and watched only me, they, you know..."
    },
    "61": {
        "startTime": 536.154,
        "endTime": 541.741,
        "transcript": "Unisnganrit'laraatnga. Quy'uqtaarvikuralaraatnga.",
        "translation": "They don't stay apart from me. They always gather around me."
    },
    "62": {
        "startTime": 542.622,
        "endTime": 553.372,
        "transcript": "Tua-i nutaan tua-i taukunek tua-i waniw' ciuqamnun quy'uqercetlemni qanrulluki, qanrulluku tauna tua-i",
        "translation": "When they had gathered in front of me, I told them, I told him"
    },
    "63": {
        "startTime": 553.779,
        "endTime": 566.529,
        "transcript": "Watuaqapiar tau͡gaam waniwa tuaten uku'urluut tutgaraanka yuaryugallratni watuaqapiar pinrilengraatnga uitatesqellua.",
        "translation": "Only at that moment, when my dear grandchildren here were missing me, I asked them to leave me just for that moment."
    },
    "64": {
        "startTime": 566.848,
        "endTime": 576.073,
        "transcript": "Tua-i tau͡gaam atataarmi tua-i pillerkaqa tekiskan nutaan tua-i tamaani umyugiurutkesqellua.",
        "translation": "I told them to be with me as much as they wanted later when it was time for me."
    },
    "65": {
        "startTime": 576.854,
        "endTime": 580.929,
        "transcript": "Aren tua-i arenqiatua.",
        "translation": "Oh my, I was disconcerted."
    },
    "66": {
        "startTime": 581.848,
        "endTime": 591.873,
        "transcript": "Tua-i taqeqanemkun taman' taqeqanrakun tanqik pikna cikcartunga'artuq. Imkut-llu tua-i tangvagtelluteng tayim' nanteqerluteng.",
        "translation": "When I was finished, when that was finished, the light up there was starting to go out. And they had me watch them as they were in some place."
    },
    "67": {
        "startTime": 592.992,
        "endTime": 599.017,
        "transcript": "Tangvagtelluteng tua-i tayim' nanteqerluteng waniw' cikcartunga'arpailgan pikna.",
        "translation": "They had me see them as they were there before the light started to go out."
    },
    "68": {
        "startTime": 599.223,
        "endTime": 605.561,
        "transcript": "Nutaan tangvanriqercamteng tua-i tayim' cikcarturluni tua-i cik'arrluni tua-i.",
        "translation": "When I stopped watching them, it started to go out, and winked out."
    },
    "69": {
        "startTime": 606.411,
        "endTime": 615.136,
        "transcript": "Cali qavarpek'nii call' waten ellalinqigcimallruunga, uicung', ellalinqigcimallruunga.",
        "translation": "Also, I didn't not sleep but given new awareness like this, cousin, I was giving new awareness."
    },
    "70": {
        "startTime": 615.392,
        "endTime": 625.805,
        "transcript": "Arenqiapaa-ll' nunakegtaar imna ayagyualriarulriani. Nunakegtaar nunaksunaqpiaq.",
        "translation": "My goodness, young people, what a paradise. The paradise where everyone wants to live in."
    },
    "71": {
        "startTime": 626.267,
        "endTime": 631.417,
        "transcript": "Tanqigcetqapiar. Tanqia ayuqaituq.",
        "translation": "It was very bright. There is no light like it."
    },
    "72": {
        "startTime": 632.061,
        "endTime": 639.561,
        "transcript": "Tuar tang imna kiartellemni maaken ayaglua, waten tua-i qavarpek'nii",
        "translation": "It seemed that as I looked around from here, like this, I wasn't sleeping"
    },
    "73": {
        "startTime": 641.718,
        "endTime": 647.968,
        "transcript": "Tuar tang imna ella nunam im' qainga waten pilleq qiliim mengliinun.",
        "translation": "It seemed that the world was like this as the land meets the horizon."
    },
    "74": {
        "startTime": 649.162,
        "endTime": 660.725,
        "transcript": "Imna-wa tang nunam qaingan can'ga tuar tang imna tua-i ulvaiyaaq im' cungakvayagaq cungackepiaq cakneq.",
        "translation": "The grass on the land was extremely green, seeming like the green [ulvaiyaaq]."
    },
    "75": {
        "startTime": 661.087,
        "endTime": 666.037,
        "transcript": "Nunam-ll' im' qainga nunaniqsaagpagta tamana tua-i.",
        "translation": "The land there was too beautiful to behold."
    },
    "76": {
        "startTime": 666.381,
        "endTime": 679.956,
        "transcript": "Waniw' tiiviinek-llu caaqama tangerqacuayaaqerqama cungagcelngurmek tangrraqama nani-kiq taman' umyuaqeqanricia cungagpak, cungackepiaq.",
        "translation": "And when I briefly watch TV once in a while and see something green, I wonder why I don't remember that extremely green place."
    },
    "77": {
        "startTime": 680.687,
        "endTime": 691.512,
        "transcript": "Tua-i ellarpallraam ilua tuar tang qiliim mengliinun tua-i nunam man'a qainga tuaterrlainaq ayuqluni tamarmi.",
        "translation": "It seemed that the land in the entire world all the way to the horizon was like that."
    },
    "78": {
        "startTime": 691.993,
        "endTime": 697.643,
        "transcript": "Nunapigmek-llu mat'utun nunapimcetun ayuqelriamek cataunani.",
        "translation": "And there was no tundra like the tundra that we have here."
    },
    "79": {
        "startTime": 698.212,
        "endTime": 706.912,
        "transcript": "Manigcetqapiar, nanvamek-llu tang tangellrunrilngua waniw' tamatum iluani kuiggarmek-llu.",
        "translation": "It was so smooth, and I didn't see a lake or a creek in there."
    },
    "80": {
        "startTime": 708.256,
        "endTime": 714.506,
        "transcript": "Arenqiapakar tua-i tang ukatmun waten uyaqunka uivurallemni",
        "translation": "My goodness, as I turned my neck like this going this way"
    },
    "81": {
        "startTime": 714.725,
        "endTime": 727.45,
        "transcript": "Maaten tang tua-i ukatmun piqertua yuut amkut pingayun nangerngaqalriit qatellriamek aturluteng imumek akurtulriamek.",
        "translation": "When I turned this way, I saw three people standing wearing long white robes."
    },
    "82": {
        "startTime": 728.581,
        "endTime": 736.519,
        "transcript": "Maaten tang tua-i yaavet tangvakaranka Jesus-aamek ilangqellinilriik ingkuk.",
        "translation": "When I watched them over there, I realized that two of them over there were accompanied by Jesus."
    },
    "83": {
        "startTime": 737.757,
        "endTime": 744.044,
        "transcript": "Atam nutaan tua-i quyavikekeka Jesus-aaq tangrrucianek.",
        "translation": "I gave greater thanks for seeing Jesus."
    },
    "84": {
        "startTime": 744.082,
        "endTime": 753.494,
        "transcript": "Cali-llu ak'a ciunguluku uksuaruluku ayagluku tua-i tangerqataruarluku tamaani ayuqengellruunga.",
        "translation": "Also, I started expecting to see him first and foremost during the fall at the time."
    },
    "85": {
        "startTime": 753.895,
        "endTime": 757.432,
        "transcript": "Tua-i waniw' tangerqataruarturluku.",
        "translation": "I kept expecting to see him."
    },
    "86": {
        "startTime": 757.682,
        "endTime": 762.282,
        "transcript": "Unugmi-llu qakmani cat qavama unicanga",
        "translation": "And the things outside at night when sleep left me"
    },
    "87": {
        "startTime": 762.751,
        "endTime": 775.989,
        "transcript": "Unugmi-llu qakmani cat avirliqa'arqata tua-i inangqangnaqsaaqvimnek maklua tua-i ella qagna kiarcaaqaqluku, agyat-llu pagkut kiarquryaaqaqluki.",
        "translation": "When the things outside started clamoring in the night, I would get up after trying to lay still and look around outside, and look at the stars above."
    },
    "88": {
        "startTime": 776.089,
        "endTime": 780.477,
        "transcript": "Avungarkaunrirqata aqumlua tua-i inartaqlua.",
        "translation": "When nothing else would happen, I would sit and lie down."
    },
    "89": {
        "startTime": 781.015,
        "endTime": 790.165,
        "transcript": "Tang ayagyualriani tua-i ella imna aling arenqiapakar ellaksuuminaqsaaqvaa-lli.",
        "translation": "You young people, you see, that world, oh my goodness, it is such a wonderful world."
    },
    "90": {
        "startTime": 790.472,
        "endTime": 800.759,
        "transcript": "Carrlugmek imaunani ellakegtaar imna. Carrlugmek tangerrnaunani. Ellam im' ayuqucia assiqapiar.",
        "translation": "That paradise had nothing bad. There was nothing bad to be seen. That world looks very good."
    },
    "91": {
        "startTime": 800.772,
        "endTime": 811.584,
        "transcript": "Tanqigceńani cakneq, tanqicukepiarluni. Amta-llu akerteḿek-llu cataunani ellam ilua.",
        "translation": "It was very bright, extremely bright. And yet there was no sun in that world."
    },
    "92": {
        "startTime": 811.747,
        "endTime": 819.035,
        "transcript": "Amta-ll' tua-i iirluaraunani tanqigceńani cakneq, tanqigpagluni.",
        "translation": "And yet it was bright, very bright, [without a source of light]."
    },
    "93": {
        "startTime": 821.873,
        "endTime": 824.623,
        "transcript": "Aling arenqiapakar.",
        "translation": "Oh my goodness."
    },
    "94": {
        "startTime": 825.142,
        "endTime": 840.167,
        "transcript": "Tua-i tuaten tua-i kiarqurallemni taukut tua-i cali yuut taukut tangvaurluki tua-i. Piinanemni call' tua-i natetmuruciinateng-llu tua-i tayim' cataiteqalallruut.",
        "translation": "As I was looking around liek that, I would watch those people too. As I did that, they would disappear and I wouldn't know where they went."
    },
    "95": {
        "startTime": 840.911,
        "endTime": 851.423,
        "transcript": "Tua-i cataiteqaata cali uyaqutka cayugluki ciuqaqa call' un' tangrraqa malruk cali ukuk ciuqamni call'.",
        "translation": "When they disappeared, I would pull back my neck and look in front of me to see two of them still in front of me."
    },
    "96": {
        "startTime": 851.486,
        "endTime": 857.911,
        "transcript": "Yaaqsiggaryuata-ll' tang elitaqengnaqengramka Jesus-aam ilai elitaqsunrilkenka.",
        "translation": "And since they were a little far, I wouldn't recognize Jesus' companions though I tried."
    },
    "97": {
        "startTime": 860.43,
        "endTime": 872.192,
        "transcript": "Aren, una ciuqaqa call' tangrraqa malrukuk ukuk, una ukaqlia sugtuluni ingna-ll' yaaqlia sugkillruluni.",
        "translation": "Oh my, I looked in front of me to see two people, the taller one on this side, and the one next to him was shorter."
    },
    "98": {
        "startTime": 872.618,
        "endTime": 881.68,
        "transcript": "Maaten tang tua-i call' taukuk tangvauraqaragak tuar tang tauna ukaqlia sugtulria Qayum atii.",
        "translation": "I looked at those two and it seemed that the taller one on this side was Qayuq's father."
    },
    "99": {
        "startTime": 882.106,
        "endTime": 886.406,
        "transcript": "Tua-i tang caqaquurallrakun elitaqnguaqeka.",
        "translation": "I felt that I recognized him by what his mannerisms."
    },
    "100": {
        "startTime": 886.663,
        "endTime": 895.75,
        "transcript": "Tua-i Qayum atak'acagii tua-i imna tua-i maantenglleq, maani uitalangelleq.",
        "translation": "It was certainly Qayuq's father that started to live here, the one who started to live here."
    },
    "101": {
        "startTime": 896.925,
        "endTime": 901.988,
        "transcript": "Tua-i tuaten tua-i piqerluku.",
        "translation": "That's all for that."
    },
    "102": {
        "startTime": 902.238,
        "endTime": 917.275,
        "transcript": "Atam tua-i tamakut tangerqengaqenriqercamki au͡gkucicetun-am call' tangvauraqarraartellutek tua-i cali tangvangramtek natetmuruciinakek tayim' cataiteqarillruagka.",
        "translation": "You see, when I stopped seeing them, after I watched those two, I lost sight of them with no idea where they went even though I was watching them."
    },
    "103": {
        "startTime": 917.913,
        "endTime": 928.713,
        "transcript": "Aren, tuar tang imna taukuk kinguagni man'a tua-i ella'urlurput wangkuta cangakevkenaku atuqengarput",
        "translation": "Oh my, it seemed that after that, our pitiful world that we live in without thinking anything of it"
    },
    "104": {
        "startTime": 929.232,
        "endTime": 944.557,
        "transcript": "Umyuama-am tekicaku tamaavet tua-i uitallemnun ituliqausnguallemni kavirrlugcelnguq-llu tuar ituliqautellemni",
        "translation": "When my mind came upon where I was together with them, it seemed it was a little red when I was alongside them"
    },
    "105": {
        "startTime": 945.388,
        "endTime": 950.863,
        "transcript": "Tua-i wangkurluumta cangakevkenaku ellakngamteggu atuamteggu.",
        "translation": "Because we live in this world without thinking anything of it."
    },
    "106": {
        "startTime": 953.357,
        "endTime": 955.382,
        "transcript": "Aren tua-i.",
        "translation": "Oh my goodness."
    },
    "107": {
        "startTime": 960.038,
        "endTime": 970.101,
        "transcript": "Nutaan taum kinguani uyaqunka cayugluki piqerlua ayuquciqa man'a cikcartuaranga'artuq cukayugnaunani.",
        "translation": "After that, I pulled my neck back and I was slow as if my body were closing up."
    },
    "108": {
        "startTime": 970.938,
        "endTime": 984.676,
        "transcript": "Tua-i cik'arcan maaten piqertua inglemni-ll' aqumgayaaqellinilrianga inarrvimni. Tua-i aqumgayaaqellinilrianga inglemni.",
        "translation": "When it closed up, I realized that I was sitting on my bed where I sleep. I was sitting on my bed."
    },
    "109": {
        "startTime": 985.201,
        "endTime": 992.751,
        "transcript": "Arenqiatua tau͡gaam waten elliryaaqeng'e'rma imnanguartua au͡g'umek ellakegtaarmek.",
        "translation": "I was in distress through I was like this imagining being in that paradise."
    },
    "110": {
        "startTime": 992.945,
        "endTime": 1000.583,
        "transcript": "Waten-ll' umyuarteqlua iluani nangerngallemni, nangerngayukellemni:",
        "translation": "And I thought this as I was standing there, when I thought I was standing there:"
    },
    "111": {
        "startTime": 1000.92,
        "endTime": 1020.16,
        "transcript": "\"Arenqiapaa-ll' nauwa-mi imkut ayagyuarugaat. Arenqiapaa-ll' maa-i-tuq man' ellakegtaar ellakluku nunaniryugluteng ellaklitgu akwarpak amavet tayima callerkameggnek umyuarteqsugnaunateng.",
        "translation": "Oh my goodness, where are all those young people. Oh my goodness, I wish that they would live in that paradise in great joy forever with no worry about what may happen in the future."
    },
    "112": {
        "startTime": 1021.124,
        "endTime": 1037.274,
        "transcript": "\"Qaillun-llu pimallerkameggnek umyuarteqsugnaunateng. Wangkuta apqemteńek tuqullerkameggnek-ll' umyuarteqsugnaunateng uitalleqsarluku maligtaqulluteng alerquutmeggnun yuukuneng.\"",
        "translation": "\"And they would have no worries about what may happen to them. And they would live there with no worries about what we call death if they live by the instructions given to them.\""
    },
    "113": {
        "startTime": 1037.906,
        "endTime": 1039.418,
        "transcript": "Tangrriu.",
        "translation": "You see?"
    },
    "114": {
        "startTime": 1040.056,
        "endTime": 1051.181,
        "transcript": "Tua-i waniw' imnanguarumalrianga wii makunek maa-i waten tang tua-i pulengtarmek pilaama.",
        "translation": "Now, I imagine these things because I do this repeatedly."
    },
    "115": {
        "startTime": 1051.487,
        "endTime": 1059.487,
        "transcript": "Tua-i-w' cam imum pivkalaqiinga. Wangnek piksailngua. Tangerrlua tua-i pivkalaraanga cam imum.",
        "translation": "Something causes me to do that. I don't do it by myself. Whatever it is sees me and causes me to do that."
    },
    "116": {
        "startTime": 1059.644,
        "endTime": 1070.781,
        "transcript": "Waten-ll' ayuquciqa tua-i tanqigmek cikilaraa waten tua-i ayuquciqa man'a tua-i tangerrluku. Nakleklua-w' tua-i pilallikiinga.",
        "translation": "It also gives me light like this seeing how I am. It probably takes pity on me."
    },
    "117": {
        "startTime": 1070.931,
        "endTime": 1078.106,
        "transcript": "Atam, atam imumi cali yaani Kuigilngurmi elitnaulallruukut Qaneryaranek.",
        "translation": "You see, we also used to learn about the Bible over in Kwigillingok back then."
    },
    "118": {
        "startTime": 1078.862,
        "endTime": 1088.55,
        "transcript": "Atam tua-i an'aqama qeraqata'arqama kaigalqa ciuqliquralaqeka.",
        "translation": "You see, when I went out and would be on my way to cross over, I would think first about my request."
    },
    "119": {
        "startTime": 1089.513,
        "endTime": 1098.55,
        "transcript": "Tua-i-am qerarlua tua-i pillemni ilura'urlurci imna tua-i enemun kiingan unitelaamku",
        "translation": "When I crossed, because I would only leave your dear cousin in the house"
    },
    "120": {
        "startTime": 1099.95,
        "endTime": 1106.613,
        "transcript": "Ayuquciqa man'a tua-i tanqiim tekiareskii uivenqegpak waten avatemni.",
        "translation": "Light came upon me in a circle around me like this."
    },
    "121": {
        "startTime": 1107.075,
        "endTime": 1109.888,
        "transcript": "Cunaw' tua-i ayagnirluni.",
        "translation": "It turned out that it started."
    },
    "122": {
        "startTime": 1110.538,
        "endTime": 1115.575,
        "transcript": "Tuaten tua-i ayagnirluni piyungaqami tua-i pilartuq.",
        "translation": "Starting from there, it comes upon me when it wants to."
    },
    "123": {
        "startTime": 1116.263,
        "endTime": 1129.25,
        "transcript": "Tua-i tau͡gaam wiinga cali waniw' imkut irniarugaanka umyuama aliayuutekenritai nantenrilata, nanelnguunateng-llu.",
        "translation": "However, my mind does not grieve over my many children because they're not anywhere else, and they are not lost."
    },
    "124": {
        "startTime": 1129.913,
        "endTime": 1139.725,
        "transcript": "Tua-i ukut ciuqliit waten tangercecimalaata-llu nanelnguicukluki umyuarteq'lartua tua-i wiinga",
        "translation": "Since the first ones appear to me, I think that they are not lost"
    },
    "125": {
        "startTime": 1139.726,
        "endTime": 1146.188,
        "transcript": "Imkut-llu kinguqliit carrlugmun tekipailegmeng tua-i tayim' ayaumarilaata.",
        "translation": "Also becaues the younger ones go before they come upon anything bad."
    },
    "126": {
        "startTime": 1146.351,
        "endTime": 1158.164,
        "transcript": "Tau͡gaam anglirillerluteng ayakatalriit tua-i cali taringnaqluteng nallunaitelallruut, taringnaqluteng.",
        "translation": "But the ones that grew a little who were going to go, I would understand because they were clear, I would understand."
    },
    "127": {
        "startTime": 1159.276,
        "endTime": 1166.801,
        "transcript": "Imkurluteng-llu, qulmun-llu yagtaarluteng piaqluteng angniyagarluteng.",
        "translation": "And the little ones, you know, would raise their hands and be happy."
    },
    "128": {
        "startTime": 1168.207,
        "endTime": 1175.495,
        "transcript": "Tua-i tamana tamaa-i umyuama eguruteksuumiitelaraa tuaten ayuqelallrat.",
        "translation": "But my mind does not want to [disregard] how they were like that."
    },
    "129": {
        "startTime": 1175.845,
        "endTime": 1186.283,
        "transcript": "Waniw' tau͡gaam wii kingunratgun cali maliggnaluki umyuarteq'laryaaqua kingunratgun maliggluki.",
        "translation": "But now, I think about going after them, going after them."
    },
    "130": {
        "startTime": 1186.533,
        "endTime": 1194.758,
        "transcript": "Tuaten yuullgukaramni qaillun umyuartequcuumiinaci, kenkutmek tau͡gaam umyuangqerrulluci.",
        "translation": "I do not want to think of my fellow people in any way except through love."
    },
    "131": {
        "startTime": 1197.689,
        "endTime": 1204.589,
        "transcript": "Kenkutmek tau͡gaam umyuangqerrulluci tamalkurpeci ilamni makuni yuullgukaramni.",
        "translation": "I only want to think of every one of you, my family, my fellow people, with love."
    },
    "132": {
        "startTime": 1204.946,
        "endTime": 1213.858,
        "transcript": "Tangerqeka tamalkuan tememtun pitarrluku tangvagyugluku umyuangqerrlua.",
        "translation": "I have the mind to see with my entire body what I've seen."
    },
    "133": {
        "startTime": 1214.659,
        "endTime": 1224.496,
        "transcript": "Tua-i waniw' au͡gkut yullret angullrenka arenqiatut.",
        "translation": "The people that I was born to see back then lived hard lives."
    },
    "134": {
        "startTime": 1224.959,
        "endTime": 1230.584,
        "transcript": "Qanruyutmeggnun niisngallruameng yuunertuqitauluteng-llu.",
        "translation": "Because they obeyed the wisdom passed down to them, they lived long lives."
    },
    "135": {
        "startTime": 1230.665,
        "endTime": 1236.29,
        "transcript": "Nunat-ll' ukut ellangviinka calriamek niitnarqeksaunateng.",
        "translation": "And we didn't hear of any misfortune in the village I grew up in."
    },
    "136": {
        "startTime": 1236.609,
        "endTime": 1246.296,
        "transcript": "Tua-i tau͡gaam akaurtenqegcaara'rqan tayima makut-llu temyigilriit iliit tua-i arulairaqluni.",
        "translation": "Only after a very long time, one of the people who had gotten old would pass away."
    },
    "137": {
        "startTime": 1247.171,
        "endTime": 1252.559,
        "transcript": "Waten-llu tua-i mat'um nalliinitun maa-i ayuqsugnaunateng.",
        "translation": "And they were nothing like how it is these days."
    },
    "138": {
        "startTime": 1253.172,
        "endTime": 1260.134,
        "transcript": "Calriit uunguciicimaaqluteng. Calriamek-llu avaqlirmeggnek naken niitaqluteng.",
        "translation": "They wouldn't know of any misfortune for a long time. And they would hear of misfortune from areas around them."
    },
    "139": {
        "startTime": 1260.71,
        "endTime": 1268.297,
        "transcript": "Niicungaqameng akaurtaqan imna tua-i tuaten piniluku yuk tauna pillrat.",
        "translation": "They would finally hear of something happening to someone after a long time."
    },
    "140": {
        "startTime": 1268.497,
        "endTime": 1271.522,
        "transcript": "Akaurtaqan tau͡gaam.",
        "translation": "But only after a long time."
    },
    "141": {
        "startTime": 1276.753,
        "endTime": 1290.353,
        "transcript": "Tua-i waniw' cali uani Qinarmiuni yungqelallratni uitangellrulrianga. Aiparma imum uitangevkallrukiinga.",
        "translation": "Now, I started living downriver in Qinarmiut when it was populated. My husband had be live there."
    },
    "142": {
        "startTime": 1291.335,
        "endTime": 1302.497,
        "transcript": "Tua-i call' waniw' nalluyagutesciigatanka makut kinguveruaraat. Nalluyagutesciiganaki kinguveruaraat makut.",
        "translation": "And now, I cannot forget these descendants. I cannot forget these descendants."
    },
    "143": {
        "startTime": 1302.873,
        "endTime": 1309.46,
        "transcript": "Tua-i elluarrluki tau͡gaam piyuumiryaaqluki tua-i.",
        "translation": "I want them to be good."
    },
    "144": {
        "startTime": 1310.11,
        "endTime": 1313.21,
        "transcript": "Tua-i qanemcitnaamken uicung'.",
        "translation": "Let me tell you a story, cousin."
    },
    "145": {
        "startTime": 1313.217,
        "endTime": 1324.054,
        "transcript": "Icivaq-am, qangvaq-am? Uksuaq piyugnarquq. Ceńavaralriim itrautengnaqsaaqaanga tengssulvagmek-gguq tengssuucirlunuk.",
        "translation": "Recently, when was it? Maybe last fall. Ceńavaralria tried to bring me upriver with what he called a huge plane."
    },
    "146": {
        "startTime": 1324.417,
        "endTime": 1326.679,
        "transcript": "Tua-i-am waten piyaaqaanga...",
        "translation": "He said this to me..."
    }
};